<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Product Information
                            </h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Title:" label-for="name">
                                    <b-form-input id="name" placeholder="Enter name" :state="validateField(name, 'text')" v-model="name" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Amount:" label-for="price">
                                    <b-form-input id="price" placeholder="Enter price" :state="validateField(price)" v-model="price" required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                          

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Quantity:" label-for="quantity">
                                    <b-form-input id="quantity" placeholder="Enter quantity" :state="validateField(quantity)" v-model="quantity"
                                        required>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Sequence / Position:" label-for="position">
                                    <b-form-input
                                        id="position"
                                        type="number"
                                        min="0"
                                        placeholder="Enter sequence/position"
                                        :state="validateField(position)"
                                        v-model="position"
                                        required
                                    >
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Description:" label-for="description">
                                    <textarea class="form-control" id="description" type="text"
                                        placeholder="Enter message" :class="{  'is-invalid': validateField(description) === false,  'is-valid': validateField(description) === true,}" v-model="description" required />
                                </b-form-group>
                            </div>

                            <div class="col-md-12 col-12">
                                <b-form-group label="Images:" label-for="images" label-class="font-weight-bold">
                                    <!-- Drag & Drop Upload Area -->
                                    <div
                                    class="border rounded p-3 text-center"
                                    style="cursor: pointer; background: #f9f9f9; min-height: 120px;"
                                    @drop.prevent="onImageDrop"
                                    @dragover.prevent
                                    @click="$refs.imageInput.click()"
                                    >
                                    <div v-if="!imagePreviews.length">
                                        <i class="fas fa-cloud-upload-alt fa-2x text-muted"></i>
                                        <h5 class="upload-title">Drag & Drop or Click to Upload</h5>
                                        <p class="upload-subtitle">Max 20 images, 2MB each</p>
                                    </div>

                                    <!-- Thumbnails Preview -->
                                    <div class="d-flex flex-wrap justify-content-center">
                                        <div
                                        v-for="(preview, index) in imagePreviews"
                                        :key="index"
                                        class="m-2 position-relative"
                                        >
                                        <img
                                            :src="preview"
                                            class="img-thumbnail"
                                            style="max-width: 120px; max-height: 120px; object-fit: cover;"
                                        />
                                        <!-- Remove button -->
                                        <b-button
                                            size="sm"
                                            variant="danger"
                                            class="position-absolute"
                                            style="top: 2px; right: 2px;"
                                            @click.stop="removeImage(index)"
                                        >
                                            ×
                                        </b-button>
                                        </div>
                                    </div>
                                    </div>

                                    <!-- Hidden File Input -->
                                    <input
                                    ref="imageInput"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    class="d-none"
                                    @change="onImageSelect"
                                    />

                                    <small class="text-muted">Allowed: JPG/PNG • Max 2MB each • Up to 20 images</small>
                                </b-form-group>
                            </div>
                        </div>

                        <!-- Bank Information End -->
                        <b-button type="submit" variant="primary" class="mb-8 mr-8" :disabled="isLoading">
                            <span v-if="!isLoading">Submit</span>
                            <b-spinner v-else class="mb-8 mr-8" variant="primary" small></b-spinner>
                        </b-button>
                    </b-form>
                </div>

                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
            <code class="hljs html">
              {{ codeText }}
            </code>
          </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BSpinner,
} from "bootstrap-vue";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            showModal: false,
            isLoading: false,
            description: "",
            name: "",
            price: "",
            quantity: "",
            position: "",
            image: [],
            successMessage: "",
            errorMessage: "",
            imagePreviews: [],
        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormInput,
        BToast,
        BSpinner,
    },
    methods: {
        validateField(value, type = "text") {
            if (value === null || value === undefined || value === "") return null;

            if (type === "email") {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(value);
            }
            if (type === "number") {
            const regex = /^\+?[0-9 ]+$/; // accepts + and spaces
            return regex.test(value.toString().trim());
            }
            return value.toString().trim().length > 0;
        },
        addUser() {
            this.isLoading = true;
            const formData = new FormData();
            formData.append("name", this.name);
            formData.append("price", this.price);
            formData.append("description", this.description);
            formData.append("quantity", this.quantity);
            formData.append("position", this.position);
            formData.append("sequence", this.position);
            if (this.image && this.image.length > 0) {
                this.image.forEach((file, index) => {
                    formData.append(`image[${index}]`, file);
                });
            }
            
            axios
                .post("ProductStore", formData)
                .then((response) => {
                    this.$bvToast.toast("Product added successfully!", {
                        title: "Success",
                        variant: "primary",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 5000,
                    });
                    this.isLoading = false;
                    this.image = [];
                    this.imagePreviews = [];
                    this.$router.push({ name: 'ListProduct' });
                })
                .catch((error) => {
                    this.errors = error.response.data.errors;
                    this.isLoading = false;
                });
        },
        onImageSelect(event) {
            const files = Array.from(event.target.files);
            this.handleFiles(files);
        },

        // Handle drag & drop
        onImageDrop(event) {
            const files = Array.from(event.dataTransfer.files);
            this.handleFiles(files);
        },

        // Validate and push files
        handleFiles(files) {
            files.forEach((file) => {
            if (!file.type.startsWith("image/")) {
                this.$bvToast.toast("Only images allowed.", {
                title: "Error",
                variant: "danger",
                solid: true,
                });
                return;
            }
            if (file.size > 2 * 1024 * 1024) {
                this.$bvToast.toast("Each image must be under 2MB.", {
                title: "Error",
                variant: "danger",
                solid: true,
                });
                return;
            }
            if (this.image.length >= 20) {
                this.$bvToast.toast("You can only upload up to 20 images.", {
                title: "Error",
                variant: "danger",
                solid: true,
                });
                return;
            }

            this.image.push(file);
            this.imagePreviews.push(URL.createObjectURL(file));
            });
        },
        removeImage(index) {
            this.image.splice(index, 1);
            this.imagePreviews.splice(index, 1);
        },
    },
};
</script>
